import React, { useState } from "react";
import axios from "../../api/axios";
import "./ConvertContractToPdfModal.css";

export default function ConvertContractToPdfModal({
  isOpen,
  onClose,
  contract,
  token,
  locale = "kz",
  onConverted = () => {},
}) {
  // хуки всегда сверху
  const t = {
    kz: {
      title: "PDF-ке түрлендіру",
      desc: "Құжат PDF форматына түрлендіріледі. Аяқталғаннан кейін келісімшартты көруге болады.",
      convert: "Келісімшарт жасау",
      cancel: "Болдырмау",
      success: "Келісімшарт дайын",
      error: "Түрлендіру қате.",
    },
    ru: {
      title: "Конвертация в PDF",
      desc: "Документ будет преобразован в формат PDF. После завершения его можно будет просмотреть.",
      convert: "Заключение договора",
      cancel: "Отмена",
      success: "Договор готов",
      error: "Ошибка конвертации.",
    },
  }[locale];

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const handleConvert = async () => {
    setErr(""); setMsg("");
    try {
      setLoading(true);
      // используем текущий токен; если бэку нужен токен moderator_registrarа — вернёт 403/401
      await axios.get(
        `/contracts/${contract?.id}/convert-pdf`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMsg(t.success);
      setTimeout(() => {
        onConverted(); // родитель перезапросит и откроет просмотр
        onClose();
      }, 500);
    } catch (e) {

      setErr(t.error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="cpdf-overlay" onMouseDown={onClose}>
      <div className="cpdf-box" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="cpdf-title">{t.title}</h3>
        <p className="cpdf-desc">{t.desc}</p>
        {err && <div className="cpdf-alert err">{err}</div>}
        {msg && <div className="cpdf-alert ok">{msg}</div>}
        <div className="cpdf-actions">
          <button className="btn-primary" onClick={handleConvert} disabled={loading}>
            {t.convert}
          </button>
          <button className="btn-secondary" onClick={onClose} disabled={loading}>
            {t.cancel}
          </button>
        </div>
      </div>
    </div>
  );
}
